<template>
  <div>
    <p class="has-text-weight-bold is-size-4 mb-1">
      {{ $t("mp:application.overview.title") }}
    </p>
    <p class="mb-5">
      {{ $t("mp:application.overview.subtitle") }}
    </p>

    <section v-if="!loaded">
      <article class="media" v-for="ll in 3" :key="ll">
        <figure class="media-left">
          <p class="image is-64x64">
            <b-skeleton circle width="64px" height="64px"></b-skeleton>
          </p>
        </figure>
        <div class="media-content">
          <div class="content">
            <p>
              <b-skeleton active></b-skeleton>
              <b-skeleton height="80px"></b-skeleton>
            </p>
          </div>
          <nav class="level is-mobile">
            <div class="level-left">
              <a class="level-item">
                <span class="icon is-small">
                  <b-skeleton></b-skeleton>
                </span>
              </a>
              <a class="level-item">
                <span class="icon is-small">
                  <b-skeleton></b-skeleton>
                </span>
              </a>
            </div>
          </nav>
        </div>
      </article>
    </section>

    <template v-if="selfOnboardingData">
      <section v-if="loaded">
        <div
          class="mp-tile is-flex is-align-items-center"
          v-for="(value, key) in selfOnboardingData"
          v-bind:key="key"
        >
          <p class="mb-1 overview-block">
            <span class="overview-question">{{ key }}</span>

            <span class="has-text-weight-medium overview-answer">
              {{ value }}
            </span>
          </p>
        </div>
      </section>
    </template>

    <template v-if="branding">
      <section v-if="loaded">
        <div class="mp-tile is-flex is-align-items-center">
          <p class="mb-1 overview-block">
            <span class="overview-question">
              {{ $t("mp:application.overview.branding.big_logo") }}
            </span>
            <span class="has-text-weight-medium overview-answer">
              <img :src="bigLogo" />
            </span>
          </p>
        </div>
        <div class="mp-tile is-flex is-align-items-center">
          <p class="mb-1 overview-block">
            <span class="overview-question">
              {{ $t("mp:application.overview.branding.compact_logo") }}
            </span>
            <span class="has-text-weight-medium overview-answer">
              <img :src="compactLogo" />
            </span>
          </p>
        </div>
        <div class="mp-tile is-flex is-align-items-center">
          <div class="mb-1 overview-block">
            <span class="overview-question">
              {{ $t("mp:application.overview.branding.primary_color") }}
            </span>
            <div
              class="overview-answer color-overview"
              :style="{
                background: branding.brandingPrimary,
              }"
            >
              <span class="has-text-weight-medium overview-answer">
                {{ branding.brandingPrimary }}
              </span>
            </div>
          </div>
        </div>
        <div class="mp-tile is-flex is-align-items-center">
          <div class="mb-1 overview-block">
            <span class="overview-question">
              {{ $t("mp:application.overview.branding.secondary_color") }}
            </span>
            <div
              class="overview-answer color-overview"
              :style="{
                background: branding.brandingSecondary,
              }"
            >
              <span class="has-text-weight-medium overview-answer">
                {{ branding.brandingSecondary }}
              </span>
            </div>
          </div>
        </div>
      </section>
    </template>

    <section v-if="loaded">
      <div
        class="mp-tile is-flex is-align-items-center"
        v-for="field in fields"
        v-bind:key="field.identifier"
      >
        <p class="mb-1 overview-block">
          <span class="overview-question">{{ field.question }}</span>

          <span class="has-text-weight-medium overview-answer">{{
            field.answer
          }}</span>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { FLOW_POSITION } from "@/utils/const";
import { mapActions, mapGetters } from "vuex";
import flowOverviewMixin from "../../mixins/flowOverviewMixin";

export default {
  name: "ApplicationFlowOverview",
  components: {},
  mixins: [flowOverviewMixin],
  props: {
    steps: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      FLOW_POSITION,
      loaded: false,
      fields: [],
      bigLogo: null,
      compactLogo: null,
    };
  },
  async mounted() {
    this.fields = await this.createFields();
    try {
      await this.getSelfOnboardingData();
      await this.getMyBranding();
      this.getLogoPreviews();
    } catch {
      console.debug("Not self onboarding");
    }
    this.loaded = true;
  },
  computed: {
    ...mapGetters({
      selfOnboardingData: "onboarding/onboardingData",
      branding: "onboarding/branding",
    }),
  },
  methods: {
    ...mapActions({
      savePosition: "application/savePosition",
      getSelfOnboardingData: "onboarding/getMyData",
      getMyBranding: "onboarding/getMyBranding",
      downloadFile: "onboarding/downloadFile",
    }),
    getLogoPreviews() {
      this.downloadFile(this.branding.bigLogo).then((logo) => {
        this.bigLogo = URL.createObjectURL(logo);
      });
      this.downloadFile(this.branding.compactLogo).then((logo) => {
        this.compactLogo = URL.createObjectURL(logo);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.overview-block {
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
  border-bottom: 1px #ecf0f6 solid;
  width: 100%;
}

.overview-question {
  color: #abbacd;
}

.overview-answer {
  text-align: right;
  float: right;
}

.color-overview {
  padding: 6.41px;
  font-weight: bold;
  color: white;
  border-radius: 8px;
  text-transform: uppercase;
  // text-shadow: 1px 0px 8px black, -1px 0px 8px black, 0px 1px 8px black,
  //   0px -1px 8px black;
}

img {
  max-height: 64px;
}
</style>
